import tzLookup from "tz-lookup";

type Coordinates = {
  latitude: number;
  longitude: number;
};

/**
 * Maps a selected place's coordinates to the IANA time zone that the
 * preferences API already persists. Keeping the boundary lookup local avoids
 * an extra third-party network request or a second Maps API entitlement.
 */
export function resolveTimezoneFromCoordinates({
  latitude,
  longitude,
}: Coordinates): string | null {
  try {
    return tzLookup(latitude, longitude);
  } catch {
    return null;
  }
}
